export const globalClasses = {
  tableDataCls:
    "last:border-b-0 border-t border-purple-100 px-6 py-2 text-sm text-gray-600 font-normal bg-white/25 text-center", // Added text-center

  tableDataSmallCls:
    "last:border-b-0 border-t border-purple-100 px-6 py-2 text-sm text-gray-600 font-normal bg-white/25",

  paginatedDataCls: (showBottomBorder, width = "min-w-[92px]") => {
    return `last:border-b-0 border-t border-purple-100 px-6 py-3 text-sm text-gray-600 font-normal bg-white/25
     text-center whitespace-nowrap`; // Added text-center
  },
  iconCls: "h-6 w-6",
  menuIcon: "h-6 w-6 mr-3",
};
